import React from "react";
import html from "./Imgs/Html.png";
import csty from "./Imgs/CStyle.png";
import JavaScript from "./Imgs/Javascript.png";
import github from "./Imgs/Github.png";
import react from "./Imgs/React.png";
import tailwind from "./Imgs/tailwindCSS.png";


// defult css is for mobile devices & sm: is used for bigger devices
const Experience = () => {
  const techs = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: csty,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: JavaScript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: github,
      title: "Github",
      style: "shadow-gray-400",
    },
    {
      id: 5,
      src: react,
      title: "React",
      style: "shadow-blue-600",
    },
    {
        id: 6,
        src: tailwind,
        title:'Tailwind CSS',
        style:'shadow-sky-400' ,
    },
  ];

  return (
    <div
      name="Experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-dvh "
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Experience
          </p>
          <p className="text-sm md:text-lg py-6">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="html" className="w-24 mx-auto" />
              <p className="text-sm md:text-lg mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
